



































import Vue from 'vue';
import VariableInput from '@/components/util/VariableInput.vue';
import FooterSimple from '@/parts/common/FooterSimple.vue';
import { passwordReissue } from "@/api/Login";
import {
  mailAddressLengthLimit,
  mailAddressConstraintErrorMessage, 
  mailAddressRegExp,
} from './constraint';
import { ErrorResponse } from '@/api/dto/Error';
import axios from 'axios';

export default Vue.extend({
  name: 'PasswordReissue',
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    'accountData.mail'(mailAddress: string) {
      this.inputs['mail'].error = (mailAddress.length <= mailAddressLengthLimit && mailAddressRegExp.test(mailAddress)) ? '' : mailAddressConstraintErrorMessage;
    },
  },
  data() {
    return {
      accountData: {
        mail: '',
      },
      inputs: {
        'mail': {name: 'メールアドレス', type: 'text', placeholder: 'メールアドレス', error: '' },
      },
      submitModal: false,
    }
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(this.accountData.mail.length <= mailAddressLengthLimit && mailAddressRegExp.test(this.accountData.mail));
    },
  },
  methods: {
    async onClickSubmit() {
      try {
        await passwordReissue({ mailAddress: this.accountData.mail })
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message != null) {
            this.$emit('errorToast', resError.message);
          }
        }
        return;
      }
      this.submitModal = true;
    },
    onPushPath(path: string) {
    this.$router.push(path, () => {}); // eslint-disable-line
    this.$emit('pushPath', path);
    },
  }
})
